import { ComponentType } from "react";
import { LocalizedValueFragment } from "gql/graphql";
import { Hidable, NotSpecified, Value } from "@/shared/value";

/**
 * Локализованное название сущности: разводит значение, «скрыто» и пустоту и оставляет
 * полный текст в нативном тултипе — название почти всегда стоит в ячейке, которая режет
 * его многоточием.
 *
 * Пустая строка внутри непустого `name` — тот же случай, что и отсутствующий `name`,
 * поэтому `whenEmpty` покрывает оба: иначе на месте названия оставался бы пустой узел.
 */
export function LocalizedName({
  data,
  whenEmpty: WhenEmpty = NotSpecified,
}: {
  data?: Hidable<LocalizedValueFragment>;
  whenEmpty?: ComponentType;
}) {
  return (
    <Value data={data} whenEmpty={WhenEmpty}>
      {(name) =>
        name.value ? (
          <span title={name.value}>{name.value}</span>
        ) : (
          <WhenEmpty />
        )
      }
    </Value>
  );
}
